import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'administracion',
        title: 'Administración',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'usuarios',
                title: 'Usuarios',
                type: 'item',
                icon: 'people',
                url: '/administracion/usuarios'
            },
            {
                id: 'roles',
                title: 'Roles',
                type: 'item',
                icon: 'portrait',
                url: '/administracion/roles'
            },
            {
                id: 'clientes',
                title: 'Clientes',
                type: 'item',
                icon: 'sentiment_very_satisfied',
                url: '/administracion/clientes'
            },
            {
                id: 'sucursales-bodegas',
                title: 'Sucursales-Bodegas',
                type: 'item',
                icon: 'store',
                url: '/administracion/sucursales-bodegas'
            },
            {
                id: 'familia-de-productos',
                title: 'Familia de Productos',
                type: 'item',
                icon: 'shopping_cart',
                url: '/administracion/familia-de-productos'
            },
            {
                id: 'administracion-de-opciones',
                title: 'Administracion de Opciones',
                type: 'item',
                icon: 'style',
                url: '/administracion/configuracion-de-opciones'
            }
        ]
    },
    {
        id: 'reportes',
        title: 'Reportes',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'produccion_reportes',
                title: 'Producción de reportes',
                type: 'item',
                icon: 'archive',
                url: '/erp/reportes'
            },
        ]
    },
    {
        id: 'documentos',
        title: 'Documentos',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'carga_documentos',
                title: 'Carga masiva de documentos',
                type: 'item',
                icon: 'cloud_upload',
                url: '/erp/documentos'
            },
        ]
    },
    {
        id: 'inventarios',
        title: 'Inventarios',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'productos',
                title: 'Productos',
                type: 'item',
                icon: 'people',
                url: '/inventarios/productos'
            },
            {
                id: 'ajustes',
                title: 'Ajustes',
                type: 'item',
                icon: 'settings',
                url: '/inventarios/ajustes'
            },
            {
                id: 'servicios',
                title: 'Servicios',
                type: 'item',
                icon: 'settings',
                url: '/inventarios/servicios'
            }
        ]
    },
    {
        id: 'cxp',
        title: 'Proveedores',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'proveedores',
                title: 'Proveedores',
                type: 'item',
                icon: 'people',
                url: '/cxp/proveedores'
            },
        ]
    },
    {
        id: 'compras',
        title: 'Compras',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'comprasOrdenes',
                title: 'Órdenes de compra',
                type: 'item',
                icon: 'people',
                url: '/compras/comprasOrdenes'
            },
            {
                id: 'compras',
                title: 'Compras',
                type: 'item',
                icon: 'settings',
                url: '/inventarios/compras'
            }
        ]
    },
    {
        id: 'cuentas',
        title: 'Cuentas',
        translate: '',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'gestionDeCobros',
                title: 'Gestión de cobros',
                type: 'item',
                icon: 'account_balance_wallet',
                url: '/cuentas/gestionDeCobros'
            }
        ]
    },
];
